import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { PowerBIEmbed } from 'powerbi-client-react';
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "./IdgfPowerBi.scss"

function IdgfPowerBi() {
  const dispatch = useDispatch();
  const embedConfig = useSelector(state => state.idgfPowerBi.embedConfig);
  const loading = useSelector(state => state.idgfPowerBi.loading);
  const errorMessage = useSelector(state => state.idgfPowerBi.errorMessage);

  useEffect(() => {
    dispatch({
      type: 'FETCH_REPORT_REQUEST',
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      {loading && <div className="loader"><LoadingSpinner /> </div>}
      {!loading && errorMessage && errorMessage.error &&
        <div className="messageErrorContainer">
          <h1 className="messageErrorHeader">Problema ao acessar o relatório IDGF</h1>
          <p className="messageError">Desculpe, houve um problema ao carregar o Power BI Embedded. Por favor, tente novamente mais tarde.</p>
          <p className="messageError">Se o problema persistir, entre em contato com o suporte.</p>

          {errorMessage.error.message && <p className="messageErrorDetails">{errorMessage.error.code}: {errorMessage.error.message}</p>}
        </div>
      }
      {embedConfig && <PowerBIEmbed
        embedConfig={embedConfig}
        cssClassName={"reportClass"}
        getEmbeddedComponent={(embeddedReport) => {
          window.report = embeddedReport;
        }}
      />
      }
    </div>
  );
};

export default withRouter(IdgfPowerBi);